import "./MenuLateral.scss";
import { useContext, useState } from "react";
import usePermissoes from "@hooks/usePermissoes";
import { useNavigate } from "react-router-dom";
import GlobalContext from "@context/GlobalContext";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";
import IconLogoNuvemMenu from "@icons/IconLogoNuvemMenu";
import MenuHierarquia from "./MenuHierarquia";

export default function MenuLateral(props) {
  //Variaveis padrões
  const [state, dispatch] = useContext(GlobalContext);
  const navigate = useNavigate();

  //open
  const [open, setOpen] = useState(false);
  const [menuAberto, setMenuAberto] = useState({});

  return (
    <>
      <div className="icon-menu">
        <ButtonIcon
          MenuLateral
          onMenuLateral={() => {
            setOpen(true);
          }}
        />
      </div>
      <div className={`menu-lateral ${open ? "open" : ""}`}>
        <div style={{ textAlign: "end" }}>
          <ButtonIcon
            MenuLateral
            onMenuLateral={() => {
              setMenuAberto({});
              setOpen(false);
            }}
          />
        </div>
        <div
          style={{
            textAlign: "center",
            marginTop: "20px",
            marginBottom: "20px",
          }}
        >
          <IconLogoNuvemMenu
            onClick={() => {
              navigate("/CAD");
            }}
          />
        </div>
        <div>
          {Object.entries(state.menulateral).map(([key, value]) => (
            <ul className="menuhierarquia">
              <MenuHierarquia
                id={key}
                data={value}
                nivel={1}
                menuAberto={menuAberto}
                setMenuAberto={setMenuAberto}
                setOpenTodoMenu={setOpen}
              />
            </ul>
          ))}
        </div>
      </div>
    </>
  );
}

MenuLateral.defaultProps = {
  nome: "Admin",
  qtdNotificacoes: 1,
  ultimoAcesso: "16/12/2024 11:01",
};
